<template>
  <div class="intro" v-if="user">
    <template v-if="+user.property.is_lead">
      <a class="intro_link" href="#" @click.prevent="startReaction">
        <span>Если ты - новый ученик, обязательно <u>посмотри это видео!</u> Ты узнаешь много интересного!</span>
      </a>
    </template>

    <Reaction :video="video" 
              :show_reaction="show_reaction" 
              @onStopReaction="stopReaction" 
              @onVideoEnd="onWatchIntro" />
  </div>
</template>

<script>
import Reaction from "../../other/reaction";
import { mapGetters } from 'vuex'

export default {
  name: "intro",
  inject: ['http'],
  components: { Reaction },
  data() {
    return {
      show_reaction: false,
      video: 'video/intro_coin.mp4',
    }
  },
  computed: {
    ...mapGetters({
      user: 'user'
    })
  },
  methods: {
    checkIntro() {
      if (
          this.user.property &&
          this.user.property.is_lead == '1' &&
          !this.user.property.watch_intro
      ) {
        this.start_reaction();
      }
    },
    startReaction() {
      this.show_reaction = true;
    },
    stopReaction() {
      this.show_reaction = false;
    },
    async onWatchIntro() {
      let data = {
        'param_name': 'watch_intro',
        'param_value': true,
        'user_id': this.user.id
      }
      await this.http.post('onUpdateUserParam', data).then(res => res.data);
    }
  },
  mounted() {
    this.checkIntro();
  }
}
</script>